import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createHistory as _createHistory } from '.';
export var createBridgeApi = function createBridgeApi(bridge, args) {
  var userConsentRequired = args.userConsentRequired;
  return {
    refresh: createBridgeMethod(bridge === null || bridge === void 0 ? void 0 : bridge.refresh),
    submit: createBridgeMethod(bridge === null || bridge === void 0 ? void 0 : bridge.submit),
    close: createBridgeMethod(bridge === null || bridge === void 0 ? void 0 : bridge.close),
    openModal: createBridgeMethod(bridge === null || bridge === void 0 ? void 0 : bridge.openModal, {
      requiresUserConsent: userConsentRequired
    }),
    showFlag: createBridgeMethod(bridge === null || bridge === void 0 ? void 0 : bridge.showFlag),
    closeFlag: createBridgeMethod(bridge === null || bridge === void 0 ? void 0 : bridge.closeFlag),
    reconcile: createBridgeMethod(bridge === null || bridge === void 0 ? void 0 : bridge.reconcile),
    onError: createBridgeMethod(bridge === null || bridge === void 0 ? void 0 : bridge.onError),
    createHistory: function createHistory() {
      return _createHistory({
        history: bridge === null || bridge === void 0 ? void 0 : bridge.history,
        extensionBasePath: bridge === null || bridge === void 0 ? void 0 : bridge.extensionBasePath
      });
    },
    changeWindowTitle: createBridgeMethod(bridge === null || bridge === void 0 ? void 0 : bridge.changeWindowTitle)
  };
};
var createBridgeMethod = function createBridgeMethod(method) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
      var _method;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!method) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", (_method = method.apply(void 0, [payload].concat(args))) !== null && _method !== void 0 ? _method : true);
          case 2:
            return _context.abrupt("return", false);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};